/**
 * Store Redux Toolkit — NexaCraft AI (docs/01-ARCHITECTURE.md § 3).
 * - `api`      : RTK Query (données métier)
 * - `authApi`  : RTK Query (authentification /auth/*)
 * - `ui`       : préférences d'interface (thème)
 * - `session`  : session utilisateur réelle (Worker /auth/*)
 * - `onboarding` : étapes du parcours d'inscription professionnel
 */
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from '../lib/api/baseApi';
import { authApi } from '../lib/api/authApi';
import { adminApi } from '../lib/api/adminApi';
import { scheduleApi } from '../lib/api/scheduleApi';
import { recommendationApi } from '../features/marketplace/api/recommendationApi';
import { calendarApi } from '../features/calendar/api/calendarApi';
import { onboardingApi } from '../features/onboarding/api/onboardingApi';
import { uiSlice } from '../features/ui/ui.slice';
import { sessionSlice } from '../features/auth/model/session.slice';
import { onboardingSlice } from '../features/onboarding/model/onboarding.slice';

const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [authApi.reducerPath]: authApi.reducer,
  [adminApi.reducerPath]: adminApi.reducer,
  [scheduleApi.reducerPath]: scheduleApi.reducer,
  [recommendationApi.reducerPath]: recommendationApi.reducer,
  [calendarApi.reducerPath]: calendarApi.reducer,
  [onboardingApi.reducerPath]: onboardingApi.reducer,
  ui: uiSlice.reducer,
  session: sessionSlice.reducer,
  onboarding: onboardingSlice.reducer,
});

export const makeStore = () => {
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefault) => getDefault().concat(baseApi.middleware, authApi.middleware, adminApi.middleware, scheduleApi.middleware, recommendationApi.middleware, calendarApi.middleware, onboardingApi.middleware),
  });
  setupListeners(store.dispatch);
  return store;
};

export const store = makeStore();

export type AppStore = ReturnType<typeof makeStore>;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
